module.exports = __webpack_public_path__ + "img/9.19fd9f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/9.png
// module id = /zuT
// module chunks = 1